<template>
<div class="assetClass-container">
  <div :class="cssClasses" v-on:click.self="handleClick($event)">
    <div class="assetClass-title"><span v-on:click.self="handleClick($event)">{{ sectionLabel }}</span><i v-if="menuData.length > 0" class="el-icon-arrow-down" v-on:click="openMenu"></i></div>
    <span class="assetClass-amount" v-on:click.self="handleClick($event)">{{ formatAmount(totalAmount) }}</span>
    <span class="assetClass-porcentage" v-on:click.self="handleClick($event)">{{ formatPercentage(percentage) }}</span>
  </div>
  <div v-if="showMenu" class="assetClass-dropwdown-menu">
    <div v-for="(item) in menuData" :key="item.name" :id="item.id" class="dropdownMenu-item" @click="goToAssetClass($event)">
      <div :class="['dropdownMenu-pointer', item.id]"><p class="dropdownMenu-title">{{item.name}}</p></div>
      <p class="dropdownMenu-amount">{{ formatAmount(item.amount)}}</p>
      <p class="dropdownMenu-porcentage">{{formatPercentage(item.percentage)}}</p>
    </div>
  </div>
</div>
</template>

<script>
/* Imports are written here */
export default {
  name: 'AssetClassMenu',
  props: {
    currentAssetClass: '',
    totalAmount: 0,
    percentage: 0,
    menuData: {},
    sectionLabel: '',
    isAssetDetail: false
  },
  data() {
    return {
      showMenu: false
    }
  },
  computed: {
    cssClasses: function () {
      let initial = {'assetClass-container-menu': true}
      initial[this.currentAssetClass] = true;
      initial["isDetail"] =this.isAssetDetail;
      return initial
    }
  },
  methods: {
    openMenu() {
      this.showMenu = !this.showMenu
    },
    handleClick (event) {
      event.preventDefault()
      if (this.isAssetDetail) {
        this.$router.push(`/analisis-portafolio/${this.$route.params.id}/mercado/${this.currentAssetClass}`)
      } else {
        this.showMenu = !this.showMenu
      }
    },
    formatPercentage (percentage) {
      percentage = percentage*100
      return `${percentage.toFixed(2)}%`
    },
    formatAmount (amount) {
      amount = parseFloat(amount) || 0
      return `$${amount.toLocaleString()}`
    },
    goToAssetClass (event) {
      event.preventDefault()
      const assetClass = event.currentTarget.id.toLowerCase()
      this.$router.push(`/analisis-portafolio/${this.$route.params.id}/mercado/${assetClass}`)
    }
  }
}
</script>

<style scoped>

  .el-icon-arrow-down {
    cursor: pointer;
  }

  .assetClass-container {
    position: relative;
    z-index: 1;
  }

  .assetClass-container-menu {
    cursor: pointer;
    color: #FFF;
    padding: 8px;
    display: flex;
    flex-direction: column;
    border-radius: 2px;
    height: 80px;
    z-index: 1;
  }

  .assetClass-container-menu.deuda {
    background-color: #97E3D6;
    border: 1px solid #97E3D6;
  }

  .assetClass-container-menu.estructurados {
    background-color: #FB8070;
    border: 1px solid #FB8070;
  }

  .assetClass-container-menu.capitales {
    background-color: #B3DE69;
    border: 1px solid #B3DE69;
  }

  .assetClass-container-menu.fondosrf {
    background-color: #C2BFE0;
    border: 1px solid #C2BFE0;
  }

  .assetClass-container-menu.fondosrv {
    background-color: #FDB462;
    border: 1px solid #FDB462;
  }

  .isDetail{
    background-color: transparent !important;
    border: 1px solid;
  }

  .assetClass-title {
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;
    color: #4A4A4A;
    font-weight: bold;
    font-size: 18px;
  }

  .assetClass-amount {
    color: #4A4A4A;
    font-size: 22px;
    font-weight: bold;
    margin-bottom: 8px;
  }

  .assetClass-porcentage {
    font-size: 14px;
    color: #4A4A4A;
  }

  .assetClass-dropwdown-menu {
    padding-top: 95px;
    top: 0;
    width: 100%;
    z-index: -1;
    position: absolute;
    box-shadow: 0 1px 2px 0 rgba(0,0,0,0.5);
    background-color: white;
    border-radius: 2px;
  }

  .assetClass-dropwdown-menu p {
    cursor: pointer;
  }

  .dropdownMenu-item {
    padding: 10px;
  }

  .dropdownMenu-item:hover {
    background-color: #F6F6F7;
  }

  .dropdownMenu-title {
    font-weight: bold;
    margin: 0 18px;
    color: #4A4A4A;
    font-size: 18px;
    width: 200px;
  }

  .dropdownMenu-amount {
    color: #848484;
    margin: 0;
    font-size: 14px;
    font-weight: 500;
  }

  .dropdownMenu-porcentage {
    color: #848484;
    font-size: 12px;
    margin: 0;
    font-weight: 500;
  }

  .dropdownMenu-pointer {
    width: 10px;
    height: 10px;
    border-radius: 10px;
    margin: 10px 0;
  }

  .dropdownMenu-pointer.deuda {
    background-color: #97E3D6;
  }

  .dropdownMenu-pointer.estructurados {
    background-color: #FB8070;
  }

  .dropdownMenu-pointer.capitales {
    background-color: #B3DE69;
  }

  .dropdownMenu-pointer.fondosrf {
    background-color: #C2BFE0;
  }

  .dropdownMenu-pointer.fondosrv {
    background-color: #FDB462;
  }

</style>



// WEBPACK FOOTER //
// src/components/AssetClassMenu.vue